import React from 'react';

export default function ArrowDownIcon(props) {
  const { stroke, ...oRest } = props
  return (
    <svg
      width={props.width || "14"}
      height={props.height || "8"}
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...oRest}
    >
      <path
        d="M1 1L7 7L13 1"
        stroke={stroke || "#737D86"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
